import { AnalyticsTypes } from '../middleware/google-analytics';
import getPageLoadTime from './getPageLoadTime';
import logToDataDog from './logToDataDog';

let logged = false;
export function setLogged(hasLogged) {
    logged = hasLogged;
}

export default function dispatchPageLoadTime(component) {
    return (dispatch, getState) => {
        const state = getState();
        const pageLoadTime = getPageLoadTime();
        let metrics = { serverTime: 0 };
        if (state.ssr && state.ssr.metrics) {
            metrics = state.ssr.metrics;
        }
        const { page, serverTime, platform } = metrics;
        const totalTime = pageLoadTime + serverTime;

        //only log on the initial url, not on client side transitions
        if (logged) {
            return;
        }

        if (totalTime < 30000) {
            logToDataDog({
                name: 'booking-web-app.front-end-timing',
                type: 'histogram',
                value: totalTime,
                tags: [`platform:${platform}`, `page:${page}`],
            });
        }

        dispatch({
            type: '@ssr/pagespeed',
            meta: {
                analytics: {
                    type: AnalyticsTypes.TrackEvent,
                    category: 'Booking Page Speed',
                    action: `${component} Page Timing`,
                    data: {
                        Label: pageLoadTime + serverTime,
                    },
                },
            },
        });
    };
}
